import React, { useState, useRef } from 'react';
import { FormGroup, Label, Input, InputGroupText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

//Assets
import "../../assets/css/textField.css"

export default function TextField({ inputClassName = "", icon, placeholder = "", multiple = false, label, onChange, onBlur, type, id, name, options, value = "", invalid, searchable = false, className, disabled, onClickIcon, style, maxLength, mask = (value) => value, creatable, accept }) {
    const inputRef = useRef(null);

    //Função acionada ao clicar no label
    const handleClickLabel = () => {
        if (inputRef.current)
            inputRef.current.focus();
    };

    //Estado de controle do valor do input creatable
    const [inputValue, setInputValue] = useState("");

    //Estilos customizados para os selects multiplos ou de pesquisa que usam o react-select
    const customStyles = {
        control: (base, state) => ({
            ...base,
            menu: provided => ({ ...provided, zIndex: 9999 }),
            borderColor: state.isFocused ?
                '#ddd' : invalid ?
                    '#DC3545' : '#ddd',
            // overwrittes hover style
            '&:hover': {
                borderColor: state.isFocused ?
                    '#ddd' : invalid ?
                        '#DC3545' : '#ddd'
            }
        })
    }

    //Função que faz o controle das teclas apertadas no select creatable
    const handleKeyDown = (event) => {
        if (!inputValue) return;
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                onChange(inputValue);
                setInputValue('');
                event.preventDefault();
        }
    };

    return (
        <FormGroup className={`textField text-left left-inner-addon ${icon ? "icon" : ""} ${className ? className : ""}`}>

            <div className='d-flex align-items-center'>
                {/*Se for passado um icone e uma função de onclick para este icone , o elemento abaixo é retornado*/}
                {icon && onClickIcon &&
                    <button className='iconTextField' onClick={onClickIcon ? onClickIcon : null}>
                        <FontAwesomeIcon icon={icon} />
                    </button>
                }
                {/*Se for passado um icone e não for passado um onclick para este icone , o elemento abaixo é retornado*/}
                {icon && !onClickIcon &&
                    <FontAwesomeIcon className=' iconTextField' icon={icon} onClick={onClickIcon ? onClickIcon : null} />
                }
                {/* Se o input for um select de multiplas opções é retornado o campo abaixo */}
                {type === "select" && multiple
                    && <Select
                        value={!!value ? value : ""}
                        onChange={onChange}
                        onBlur={onBlur}
                        isClearable
                        isMulti
                        name={name}
                        options={options}
                        placeholder={placeholder != "" ? placeholder : "Selecione"}
                        className={"basic-multi-select w-100 " + `${inputClassName}`}
                        classNamePrefix="select"
                        isDisabled={disabled}
                        styles={customStyles}
                    />
                }
                {/* Se o input for um select de multiplas opções é retornado o campo abaixo */}
                {type === "select" && creatable
                    &&
                    <CreatableSelect
                        className='w-100'
                        components={{
                            DropdownIndicator: null,
                        }}
                        inputValue={inputValue}
                        isClearable
                        isMulti
                        menuIsOpen={false}
                        onChange={onChange}
                        onInputChange={(newValue) => setInputValue(newValue)}
                        onKeyDown={handleKeyDown}
                        placeholder={placeholder}
                        value={!!value ? value : ""}
                        styles={customStyles}
                        isDisabled={disabled}
                    />
                }
                {/* Se o select for do tipo pesquisavel é retornado o campo abaixo */}
                {type === "select" && searchable
                    && <Select
                        classNamePrefix={"custom-react-select"}
                        isClearable
                        value={!!value ? value : ""}
                        onChange={onChange}
                        onBlur={onBlur}
                        isSearchable
                        name={name}
                        options={options}
                        placeholder={placeholder != "" ? placeholder : "Selecione"}
                        className="basic-multi-select w-100"
                        isDisabled={disabled}
                        styles={customStyles}
                    />
                }
                {/* Se o select for normal é retornado o campo abaixo */}
                {type == "select" && !multiple && !searchable && !creatable &&
                    < Input innerRef={inputRef} autoComplete="off" className={`${inputClassName}`} onBlur={onBlur} maxLength={maxLength ? maxLength : "1000000000"} disabled={disabled} placeholder={placeholder} id={id} type={type} invalid={invalid} name={name} onChange={onChange} value={!!value ? value : ""} style={style} >
                        {
                            options && options.map((option, key) => {
                                return <option key={key} value={option.value} data-thumbnail={option.image ? option.image : ""}>{option.label}</option>
                            })
                        }
                    </Input>
                }
                {/*Se o input for do tipo checkbox é retornado o campo abaixo */}
                {type === "checkbox" &&
                    <Input innerRef={inputRef} autoComplete="off" className={`input ${inputClassName}`} onBlur={onBlur} maxLength={maxLength ? maxLength : "1000000000"} disabled={disabled} placeholder={placeholder} id={id} type={type} invalid={invalid} name={name} onChange={onChange} checked={value} />
                }
                {/*Se o input for do tipo checkbox é retornado o campo abaixo */}
                {type === "radio" &&
                    <FormGroup disabled={disabled} tag="fieldset">
                        <div className='d-flex align-items-center justify-content-start mt-3'>
                            {
                                options.map((option, key) => {
                                    return (<FormGroup check className='me-3' key={key}>
                                        <Label check>
                                            <Input type={type} name={name} onChange={onChange} value={option.value} checked={option.value == value} />{' '}
                                            {option.label}
                                        </Label>
                                    </FormGroup>)

                                })
                            }
                        </div>
                    </FormGroup>

                }
                {/*Se o input não for nem select nem checkbox é retornado o campo abaixo*/}
                {type !== "select" && type !== "checkbox" && type !== "file" && type != "radio" &&
                    <Input innerRef={inputRef} autoComplete="off" className={`input ${inputClassName}`} onBlur={onBlur} maxLength={maxLength ? maxLength : "1000000000"} disabled={disabled} placeholder={placeholder} id={id} type={type} invalid={invalid} name={name} onChange={(e) => {
                        e.target.value = mask(e.target.value, true);
                        onChange(e)
                    }} value={mask(value)} />
                }
                {/* Se o tipo de input for file então retorna o seguinte objeto */}
                {type === "file" &&
                    <Input innerRef={inputRef} autoComplete="off" className={`input ${inputClassName}`} onBlur={onBlur} maxLength={maxLength ? maxLength : "1000000000"} disabled={disabled} placeholder={placeholder} id={id} type={type} invalid={invalid} name={name} onChange={onChange} accept={accept} />
                }
                {label && <Label onClick={handleClickLabel} for={id} className={`${value != "" || type == "radio" || type == "file" || type == "select" || type == "date" ? "label-active" : ""} label ${invalid ? "text-danger" : ""}`}>{label}</Label>}
            </div>
        </FormGroup >
    )
}